import React, { useState, useEffect } from 'react';
import { FaSyncAlt } from 'react-icons/fa';
import { PURPLE, hexToRgba } from '../utils/designUtils';

const VatCalculator = () => {
    const [calcMode, setCalcMode] = useState('total');
    const [inputValue, setInputValue] = useState('');
    const [result, setResult] = useState({ supply: 0, vat: 0, total: 0 });

    useEffect(() => {
        const num = Number(inputValue.replace(/[^0-9]/g, ''));
        if (calcMode === 'total') {
            const supply = Math.round(num / 1.1);
            const vat = num - supply;
            setResult({ supply, vat, total: num });
        } else {
            const vat = Math.floor(num * 0.1);
            const total = num + vat;
            setResult({ supply: num, vat, total });
        }
    }, [inputValue, calcMode]);

    const format = (num) => new Intl.NumberFormat('ko-KR').format(num);

    const tabStyle = (active) => ({
        flex: 1, height: 30, borderRadius: 7, border: 'none',
        background: active ? 'white' : 'transparent',
        color: active ? '#2a2a3a' : '#8b8a99',
        fontWeight: active ? 600 : 500, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
        boxShadow: active ? '0 1px 3px rgba(60,50,120,.10)' : 'none',
        transition: 'all 140ms',
    });

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                        width: 28, height: 28, borderRadius: 8,
                        background: hexToRgba(PURPLE, 0.12),
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: PURPLE, fontWeight: 700, fontSize: 13,
                    }}>₩</div>
                    <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#1f1d2e' }}>부가세 계산기</h3>
                </div>
                <button onClick={() => setInputValue('')} style={{
                    background: 'transparent', border: 'none', padding: 4, cursor: 'pointer',
                    color: '#aaa9b7', display: 'flex',
                }} title="초기화">
                    <FaSyncAlt size={14}/>
                </button>
            </div>

            <div style={{
                display: 'flex', gap: 2, padding: 3, background: '#f4f3f9',
                borderRadius: 10, marginBottom: 14,
            }}>
                <button style={tabStyle(calcMode === 'total')} onClick={() => { setCalcMode('total'); setInputValue(''); }}>합계액 기준</button>
                <button style={tabStyle(calcMode === 'supply')} onClick={() => { setCalcMode('supply'); setInputValue(''); }}>공급가 기준</button>
            </div>

            <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 500, color: '#8b8a99', marginBottom: 6, letterSpacing: '.06em' }}>
                    {calcMode === 'total' ? '합계금액 TOTAL' : '공급가액 SUPPLY'}
                </div>
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    background: '#fafaff', border: '1.5px solid #ececf2', borderRadius: 10,
                    padding: '0 14px', height: 46,
                }}>
                    <input
                        value={inputValue ? format(inputValue.replace(/[^0-9]/g, '')) : ''}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{
                            flex: 1, border: 'none', outline: 'none', background: 'transparent',
                            fontSize: 18, fontWeight: 600, color: '#1f1d2e',
                            fontFamily: 'inherit', textAlign: 'right',
                        }}
                    />
                    <span style={{ fontSize: 13, color: '#8b8a99', fontWeight: 500 }}>원</span>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12.5, color: '#5d5b6e' }}>공급가액</span>
                    <span style={{ fontSize: 13.5, color: calcMode === 'supply' ? '#aaa9b7' : '#2a2a3a', fontWeight: 500 }}>
                        {format(result.supply)}<span style={{ fontSize: 11, color: '#aaa9b7', marginLeft: 2 }}>원</span>
                    </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12.5, color: '#5d5b6e' }}>부가세 (10%)</span>
                    <span style={{ fontSize: 13.5, color: '#2a2a3a', fontWeight: 500 }}>
                        {format(result.vat)}<span style={{ fontSize: 11, color: '#aaa9b7', marginLeft: 2 }}>원</span>
                    </span>
                </div>
                <div style={{ height: 1, background: '#f0eff5', margin: '2px 0' }}/>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12.5, fontWeight: 600, color: '#1f1d2e' }}>최종 합계</span>
                    <span style={{ fontSize: 17, fontWeight: 700, color: PURPLE }}>
                        {format(result.total)} <span style={{ fontSize: 12, color: '#8b8a99', fontWeight: 500 }}>원</span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default VatCalculator;
